var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { persistent: "", "max-width": "800" },
      model: {
        value: _vm.isOpen,
        callback: function($$v) {
          _vm.isOpen = $$v
        },
        expression: "isOpen"
      }
    },
    [
      _c(
        "v-card",
        [
          _c("v-card-title", [
            _c("span", { staticClass: "headline" }, [
              _vm._v(
                " " + _vm._s(_vm.isNewRule ? "Add new rule" : "Edit rule") + " "
              )
            ])
          ]),
          _c(
            "v-card-text",
            [
              _c(
                "v-form",
                {
                  ref: "form",
                  attrs: { "lazy-validation": "" },
                  model: {
                    value: _vm.valid,
                    callback: function($$v) {
                      _vm.valid = $$v
                    },
                    expression: "valid"
                  }
                },
                [
                  _c(
                    "v-container",
                    [
                      _c(
                        "v-row",
                        [
                          _c("v-text-field", {
                            attrs: {
                              rules: [
                                function(v) {
                                  return (
                                    !v ||
                                    v.length <= 30 ||
                                    "Name cannot be longer than 30 characters"
                                  )
                                }
                              ],
                              counter: "30",
                              label: "Name"
                            },
                            model: {
                              value: _vm.rule.name,
                              callback: function($$v) {
                                _vm.$set(_vm.rule, "name", $$v)
                              },
                              expression: "rule.name"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        [
                          _c("v-select", {
                            attrs: {
                              items: _vm.allowedRuleTypes,
                              rules: [
                                function(v) {
                                  return !!v || "Rule type is required"
                                }
                              ],
                              label: "Rule type",
                              required: ""
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "selection",
                                fn: function(ref) {
                                  var item = ref.item
                                  return [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.formatRuleTypeToString(item)
                                        ) +
                                        " "
                                    )
                                  ]
                                }
                              },
                              {
                                key: "item",
                                fn: function(ref) {
                                  var item = ref.item
                                  return [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.formatRuleTypeToString(item)
                                        ) +
                                        " "
                                    )
                                  ]
                                }
                              }
                            ]),
                            model: {
                              value: _vm.selectedRuleType,
                              callback: function($$v) {
                                _vm.selectedRuleType = $$v
                              },
                              expression: "selectedRuleType"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-slide-y-transition",
                        { attrs: { group: "", "hide-on-leave": "" } },
                        [
                          _vm.selectedRuleType ===
                          _vm.priceRuleTypes.DayTypeTimeRange
                            ? [
                                _c(
                                  "div",
                                  { key: "1" },
                                  [
                                    _c(
                                      "v-row",
                                      [
                                        _c("v-select", {
                                          attrs: {
                                            items: Object.values(_vm.dayTypes),
                                            rules: [
                                              function(v) {
                                                return (
                                                  !!v || "Day type is required"
                                                )
                                              }
                                            ],
                                            label: "Day type",
                                            required: ""
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "selection",
                                                fn: function(ref) {
                                                  var item = ref.item
                                                  return [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.dayTypeToString(
                                                            item
                                                          )
                                                        ) +
                                                        " "
                                                    )
                                                  ]
                                                }
                                              },
                                              {
                                                key: "item",
                                                fn: function(ref) {
                                                  var item = ref.item
                                                  return [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.dayTypeToString(
                                                            item
                                                          )
                                                        ) +
                                                        " "
                                                    )
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            false,
                                            1064404700
                                          ),
                                          model: {
                                            value:
                                              _vm.dayTypeTimeRange.dayTypes,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.dayTypeTimeRange,
                                                "dayTypes",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "dayTypeTimeRange.dayTypes"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c("v-switch", {
                                      attrs: { label: "Whole day" },
                                      model: {
                                        value: _vm.isWholeDay,
                                        callback: function($$v) {
                                          _vm.isWholeDay = $$v
                                        },
                                        expression: "isWholeDay"
                                      }
                                    }),
                                    _c(
                                      "v-row",
                                      [
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "2" } },
                                          [
                                            _c("v-text-field", {
                                              attrs: {
                                                label: "From",
                                                disabled: _vm.isWholeDay,
                                                type: "time",
                                                step: "1",
                                                required: "",
                                                rules: [
                                                  function(v) {
                                                    return (
                                                      !!v ||
                                                      "Start time is required"
                                                    )
                                                  }
                                                ]
                                              },
                                              model: {
                                                value:
                                                  _vm.dayTypeTimeRange.start,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.dayTypeTimeRange,
                                                    "start",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "dayTypeTimeRange.start"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "2" } },
                                          [
                                            _c("v-text-field", {
                                              attrs: {
                                                label: "To",
                                                disabled: _vm.isWholeDay,
                                                type: "time",
                                                step: "1",
                                                required: "",
                                                rules: [
                                                  function(v) {
                                                    return (
                                                      !!v ||
                                                      "End time is required"
                                                    )
                                                  }
                                                ]
                                              },
                                              model: {
                                                value: _vm.dayTypeTimeRange.end,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.dayTypeTimeRange,
                                                    "end",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "dayTypeTimeRange.end"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ]
                            : _vm.selectedRuleType ===
                              _vm.priceRuleTypes.CarType
                            ? [
                                _c(
                                  "div",
                                  { key: "2" },
                                  [
                                    _c(
                                      "v-row",
                                      [
                                        _c("v-select", {
                                          attrs: {
                                            items: Object.values(_vm.carTypes),
                                            rules: [
                                              function(v) {
                                                return (
                                                  !!v || "Car type is required"
                                                )
                                              }
                                            ],
                                            label: "Car type",
                                            required: ""
                                          },
                                          scopedSlots: _vm._u([
                                            {
                                              key: "selection",
                                              fn: function(ref) {
                                                var item = ref.item
                                                return [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.carTypeToString(
                                                          item
                                                        )
                                                      ) +
                                                      " "
                                                  )
                                                ]
                                              }
                                            },
                                            {
                                              key: "item",
                                              fn: function(ref) {
                                                var item = ref.item
                                                return [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.carTypeToString(
                                                          item
                                                        )
                                                      ) +
                                                      " "
                                                  )
                                                ]
                                              }
                                            }
                                          ]),
                                          model: {
                                            value: _vm.carType,
                                            callback: function($$v) {
                                              _vm.carType = $$v
                                            },
                                            expression: "carType"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ]
                            : _vm.selectedRuleType ===
                              _vm.priceRuleTypes.PassengerCount
                            ? [
                                _c(
                                  "div",
                                  { key: "3" },
                                  [
                                    _c(
                                      "v-row",
                                      [
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "2" } },
                                          [
                                            _c("v-text-field", {
                                              attrs: {
                                                label: "Min",
                                                "prepend-icon": "mdi-account",
                                                required: "",
                                                rules: [
                                                  function(v) {
                                                    return (
                                                      !!v ||
                                                      "Minimun amount of passengers is required"
                                                    )
                                                  }
                                                ]
                                              },
                                              model: {
                                                value: _vm.passengerCount.min,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.passengerCount,
                                                    "min",
                                                    $$v
                                                  )
                                                },
                                                expression: "passengerCount.min"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "2" } },
                                          [
                                            _c("v-text-field", {
                                              attrs: {
                                                label: "Max",
                                                "prepend-icon":
                                                  "mdi-account-multiple",
                                                required: "",
                                                rules: [
                                                  function(v) {
                                                    return (
                                                      !!v ||
                                                      "Maximum amount of passengers is required"
                                                    )
                                                  }
                                                ]
                                              },
                                              model: {
                                                value: _vm.passengerCount.max,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.passengerCount,
                                                    "max",
                                                    $$v
                                                  )
                                                },
                                                expression: "passengerCount.max"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ]
                            : _vm.selectedRuleType === _vm.priceRuleTypes.Range
                            ? [
                                _c(
                                  "div",
                                  { key: "3" },
                                  [
                                    _c(
                                      "v-row",
                                      [
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "6" } },
                                          [
                                            _c("v-text-field", {
                                              attrs: {
                                                label: "Distance range start",
                                                hint:
                                                  "Can be left empty for open ended range",
                                                "persistent-hint": "",
                                                "prepend-icon": "mdi-account",
                                                min: "0",
                                                step: "1",
                                                type: "number",
                                                rules: [
                                                  function(v) {
                                                    return (
                                                      v === "" ||
                                                      !!Number.isInteger(
                                                        parseFloat(v)
                                                      ) ||
                                                      "Range has to be in integers"
                                                    )
                                                  }
                                                ]
                                              },
                                              model: {
                                                value: _vm.distanceRange.start,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.distanceRange,
                                                    "start",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "distanceRange.start"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "6" } },
                                          [
                                            _c("v-text-field", {
                                              attrs: {
                                                label: "Distance range end",
                                                hint:
                                                  "Can be left empty for open ended range",
                                                "persistent-hint": "",
                                                "prepend-icon": "mdi-account",
                                                min: "0",
                                                step: "1",
                                                type: "number",
                                                rules: [
                                                  function(v) {
                                                    return (
                                                      v === "" ||
                                                      !!Number.isInteger(
                                                        parseFloat(v)
                                                      ) ||
                                                      "Range has to be in integers"
                                                    )
                                                  }
                                                ]
                                              },
                                              model: {
                                                value: _vm.distanceRange.end,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.distanceRange,
                                                    "end",
                                                    $$v
                                                  )
                                                },
                                                expression: "distanceRange.end"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ]
                            : _vm.selectedRuleType ===
                              _vm.priceRuleTypes.FixedRoute
                            ? [
                                _c(
                                  "div",
                                  { key: "4" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "pickup-location-header" },
                                      [
                                        _c("v-icon", [_vm._v("place")]),
                                        _vm._v(" Pickup location")
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-row",
                                      [
                                        _c("v-text-field", {
                                          attrs: {
                                            label: "Street name",
                                            required: "",
                                            rules: [
                                              function(v) {
                                                return (
                                                  !!v ||
                                                  "Street name is required"
                                                )
                                              }
                                            ]
                                          },
                                          model: {
                                            value: _vm.pickupLocation.street,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.pickupLocation,
                                                "street",
                                                $$v
                                              )
                                            },
                                            expression: "pickupLocation.street"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-row",
                                      [
                                        _c("v-text-field", {
                                          attrs: {
                                            label: "Street Number (regex)",
                                            hint:
                                              "eg. ^[1-9]$|^10$ from 1 to 10 or ^[1-9][0-9]?$|^100$ from 1 to 100",
                                            "persistent-hint": "",
                                            required: ""
                                          },
                                          model: {
                                            value:
                                              _vm.pickupLocation.streetNumber,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.pickupLocation,
                                                "streetNumber",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "pickupLocation.streetNumber"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-row",
                                      [
                                        _c(
                                          "v-col",
                                          {
                                            staticClass: "pl-0",
                                            attrs: { cols: "12", sm: "3" }
                                          },
                                          [
                                            _c("v-text-field", {
                                              attrs: {
                                                label: "Zipcode (optional)"
                                              },
                                              model: {
                                                value:
                                                  _vm.pickupLocation.zipcode,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.pickupLocation,
                                                    "zipcode",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "pickupLocation.zipcode"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-col",
                                          { staticClass: "px-0" },
                                          [
                                            _c("v-text-field", {
                                              attrs: {
                                                label: "City",
                                                required: "",
                                                rules: [
                                                  function(v) {
                                                    return (
                                                      !!v || "City is required"
                                                    )
                                                  }
                                                ]
                                              },
                                              model: {
                                                value: _vm.pickupLocation.city,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.pickupLocation,
                                                    "city",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "pickupLocation.city"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "pickup-location-header" },
                                      [
                                        _c("v-icon", [_vm._v("place")]),
                                        _vm._v(" Drop off location")
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-row",
                                      [
                                        _c("v-text-field", {
                                          attrs: {
                                            label: "Street name",
                                            required: "",
                                            rules: [
                                              function(v) {
                                                return (
                                                  !!v ||
                                                  "Street name is required"
                                                )
                                              }
                                            ]
                                          },
                                          model: {
                                            value: _vm.dropoffLocation.street,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.dropoffLocation,
                                                "street",
                                                $$v
                                              )
                                            },
                                            expression: "dropoffLocation.street"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-row",
                                      [
                                        _c("v-text-field", {
                                          attrs: {
                                            label: "Street Number (regex)",
                                            hint:
                                              "eg. ^[1-9]$|^10$ from 1 to 10 or ^[1-9][0-9]?$|^100$ from 1 to 100",
                                            "persistent-hint": "",
                                            required: ""
                                          },
                                          model: {
                                            value:
                                              _vm.dropoffLocation.streetNumber,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.dropoffLocation,
                                                "streetNumber",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "dropoffLocation.streetNumber"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-row",
                                      [
                                        _c(
                                          "v-col",
                                          {
                                            staticClass: "pl-0",
                                            attrs: { cols: "12", sm: "3" }
                                          },
                                          [
                                            _c("v-text-field", {
                                              attrs: {
                                                label: "Zipcode (optional)"
                                              },
                                              model: {
                                                value:
                                                  _vm.dropoffLocation.zipcode,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.dropoffLocation,
                                                    "zipcode",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "dropoffLocation.zipcode"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-col",
                                          { staticClass: "px-0" },
                                          [
                                            _c("v-text-field", {
                                              attrs: {
                                                label: "City",
                                                required: "",
                                                rules: [
                                                  function(v) {
                                                    return (
                                                      !!v || "City is required"
                                                    )
                                                  }
                                                ]
                                              },
                                              model: {
                                                value: _vm.dropoffLocation.city,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.dropoffLocation,
                                                    "city",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "dropoffLocation.city"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-row",
                                      [
                                        _c("v-checkbox", {
                                          attrs: {
                                            label: "Bidirectional",
                                            hint:
                                              "Trip can start or end at either location",
                                            "persistent-hint": "",
                                            required: ""
                                          },
                                          model: {
                                            value: _vm.bidirectional,
                                            callback: function($$v) {
                                              _vm.bidirectional = $$v
                                            },
                                            expression: "bidirectional"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ]
                            : _vm._e()
                        ],
                        2
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-card-actions",
            { staticClass: "pb-4" },
            [
              _c("v-spacer"),
              _vm.isNewRule
                ? _c(
                    "v-btn",
                    {
                      attrs: {
                        disabled: !_vm.valid,
                        loading: _vm.isUpdating,
                        color: "success"
                      },
                      on: { click: _vm.createRule }
                    },
                    [_vm._v(" Add rule ")]
                  )
                : _c(
                    "v-btn",
                    {
                      attrs: { disabled: !_vm.valid, color: "primary" },
                      on: { click: _vm.saveRule }
                    },
                    [_vm._v(" Save changes ")]
                  ),
              _c(
                "v-btn",
                {
                  staticClass: "ml-4",
                  on: {
                    click: function($event) {
                      return _vm.$emit("close")
                    }
                  }
                },
                [_vm._v(" Cancel ")]
              ),
              _c("v-spacer")
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }